import axios from 'axios'
import { REACT_APP_API } from '../../config'

export default async function updateAccountStatus(idAccount, status) {
    let results = '';
    try {
        results = await axios.put(
            `${REACT_APP_API}/integrations/accountStatus/${idAccount}`,
            status
        )
    } catch (error) {
        results = error.message;
    }
    return results;
}
